import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import BREAKPOINTS from '@mlb/react-patterns/style/breakpoints.ts';
import { getIsTouchDevice } from 'bdvp-common/src/utils';
import { useMedia } from 'bdvp-common/src/hooks';
import { useDictionary } from 'bdvp-common/src/hooks/config';

import ReelsButton from '../ReelsButton';
import TrimmingModal from '../TrimmingModal';
import Popover from './Popover';
import Modal from './Modal';

const Reels = (props) => {

    const {
        isOpen,
        toggleReelCreation,
        closeReelCreation,
        openReelCreationModal,
        openClipTrimming,
        onTrimmingOpened,
        onTrimmingClosed,
        removeClip,
        reorder,
        reel,
        clipsLoading,
        clipsData,
        isLoggedIn,
        userId,
    } = props;

    const {
        reels_text: reelsText = 'Reels',
    } = useDictionary();

    const [
        isClient,
        setIsClient,
    ] = useState(false);

    useEffect(() => {

        setIsClient(true);

    }, []);

    const isModal = useMedia([`(min-width: ${BREAKPOINTS.md})`], [false], true);

    const isTouchDevice = isClient && getIsTouchDevice();
    const button = (
        <ReelsButton
            label={reelsText}
            onClick={toggleReelCreation}
            clipsNumber={reel?.reelClips?.length}
            disabled={!isClient}
            active={isOpen}
            hasHover={!isTouchDevice}
        />
    );

    if (!isClient) {

        return button;

    }

    const Component = isModal ? Modal : Popover;

    return (
        <>
            <Component
                button={button}
                isOpen={isOpen}
                onClosed={closeReelCreation}
                reel={reel}
                clipsLoading={clipsLoading}
                clipsData={clipsData}
                removeClip={removeClip}
                reorder={reorder}
                openReelCreationModal={openReelCreationModal}
                openClipTrimming={openClipTrimming}
                isLoggedIn={isLoggedIn}
                userId={userId}
            />
            <TrimmingModal
                onOpened={onTrimmingOpened}
                onClosed={onTrimmingClosed}
            />
        </>
    );

};

Reels.propTypes = {
    closeReelCreation: PropTypes.func.isRequired,
    toggleReelCreation: PropTypes.func.isRequired,
    openReelCreationModal: PropTypes.func.isRequired,
    openClipTrimming: PropTypes.func.isRequired,
    removeClip: PropTypes.func.isRequired,
    reorder: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    reel: PropTypes.shape({
        reelClips: PropTypes.array,
        duration: PropTypes.number,
        reelTitle: PropTypes.string,
        videoUrl: PropTypes.string,
        thumbnailUrl: PropTypes.string,
    }),
    clipsLoading: PropTypes.bool,
    clipsData: PropTypes.array,
    isLoggedIn: PropTypes.bool.isRequired,
    userId: PropTypes.string.isRequired,
};

Reels.defaultProps = {
    reel: {
        reelClips: [],
        duration: null,
        reelTitle: null,
        videoUrl: null,
        thumbnailUrl: null,
    },
    clipsLoading: false,
    clipsData: [],
};


export default Reels;


